import { PromiseToPayService } from "../../../../../services/PromiseToPayService";
import { useState } from "react";
import { FaTrash, FaTriangleExclamation } from "react-icons/fa6";
import { ModalWraper } from "../../../../../components/modal/wraper";

export const DeletePromiseToPayModal = ({
    refresh,
    openModal,
    setOpenModal,
    data,
}) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            // Jalankan fungsi hapus yang diberikan dari parent
            await PromiseToPayService.delete({ id: data.id });

            // Jika sukses, tutup modal
            if (refresh) refresh();
            setOpenModal(false);
        } catch (error) {
            console.error("Gagal menghapus:", error);
            // Bisa tambahkan alert/toast disini jika gagal
            alert("Terjadi kesalahan saat menghapus data.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraper
            isOpen={openModal}
            setIsOpen={setOpenModal}
            title="Konfirmasi Hapus"
            icon={<FaTrash className="text-red-500" />}
        >
            <div className="text-center space-y-4">

                {/* Icon Peringatan */}
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-500/10 border border-red-500/20">
                    <FaTriangleExclamation className="h-8 w-8 text-red-500" />
                </div>

                {/* Pesan Konfirmasi */}
                <div>
                    <h3 className="text-lg font-semibold leading-6 text-white">
                        Apakah Anda yakin?
                    </h3>
                    <p className="mt-2 text-sm text-slate-400">
                        Tindakan ini akan menghapus data ini secara permanen.
                        Data yang sudah dihapus tidak dapat dikembalikan.
                    </p>
                </div>

                {/* Tombol Aksi */}
                <div className="flex gap-3 pt-4">
                    <button
                        type="button"
                        onClick={() => setOpenModal(false)}
                        className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 font-medium hover:bg-slate-800/50 transition-colors"
                    >
                        Batal
                    </button>

                    <button
                        onClick={handleDelete}
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl bg-red-600 hover:bg-red-500 disabled:bg-slate-700 disabled:text-slate-500 text-white font-semibold flex items-center justify-center gap-2 transition-all shadow-lg shadow-red-900/20"
                    >
                        {loading ? (
                            <>Menghapus...</>
                        ) : (
                            <>Ya, Hapus</>
                        )}
                    </button>
                </div>
            </div>
        </ModalWraper>
    );
};